module.exports = __webpack_public_path__ + "static/media/view-documents.ca0bf95b.svg";